<template>
	<div class="chevron-move">
		<Chevron v-bind="$attrs" class="mover" />
	</div>
</template>

<script>
import Chevron from './Chevron.vue'

export default {
	name: 'ChevronMove',
	components: {
		Chevron,
	},
}
</script>

<style scoped lang="scss">
.chevron-move {
	height: 100%;
	width: 100%;
	display: grid;
	place-items: center;
	position: relative;
	overflow: hidden;

	.mover {
		animation: moveIn 150ms linear;
		display: block;
		padding: 0;
		margin: 0;
	}

	&:hover {
		.mover {
			animation: moveOut 150ms linear forwards;
		}
	}
}

@keyframes moveOut {
	0% {
		transform: translateX(0);
	}
	100% {
		transform: translateX(200%);
	}
}

@keyframes moveIn {
	0% {
		transform: translateX(-200%);
	}
	100% {
		transform: translateX(0);
	}
}
</style>
